import React from 'react';
import compose from 'recompose/compose';
import branch from 'recompose/branch';
import withHandlers from 'recompose/withHandlers';
import withPropsOnChange from 'recompose/withPropsOnChange';
import withState from 'recompose/withState';
import CanvasMap from './CanvasMap';
import MapUtil from 'common/utils/MapUtil';
import setDisplayName from 'recompose/setDisplayName';

const canvasHoverMapComponent = ({
    visibleMarkers,
    canvasMarkers,
    refresh,
    draggable,
    ...props
}) => {
    return (
        <CanvasMap
            refresh={refresh}
            draggable={draggable}
            markers={canvasMarkers}
            {...props}
        >
            {visibleMarkers}
        </CanvasMap>
    );
};

export const canvasHoverMapHOC = compose(
    branch(
        ({ onHoveredMarkerChange }) => !onHoveredMarkerChange,
        withState('hoveredMarker', 'onHoveredMarkerChange', null)
    ),
    withHandlers({
        onMarkerMouseEnter: ({ onHoveredMarkerChange }) => marker => {
            onHoveredMarkerChange(marker);
        },
        onMarkerMouseLeave: ({ onHoveredMarkerChange }) => () => {
            onHoveredMarkerChange(null);
        }
    }),
    withPropsOnChange(
        ['hoveredMarker', 'children', 'disableDrag'],
        ({ hoveredMarker, children, disableDrag }) => {
            let visibleMarkers = [];
            const canvasMarkers = [];
            children.forEach(marker => {
                const {
                    isSelected,
                    isPopupOpen,
                    isHovered,
                    isSelectedForEdit,
                    isBeingEdited,
                    isCanvasMarker,
                    children: markerChildren
                } = marker.props;
                let isPopupAttached = false;
                let cluster = [];
                if (markerChildren && markerChildren.props) {
                    ({ isPopupAttached, cluster } = markerChildren.props);
                }
                const isAnyChildSelected = MapUtil.isAnyChildSelected(cluster);
                const isAnyChildHovered = MapUtil.isAnyChildHovered(cluster);
                const isAnyChildSelectedForEdit = MapUtil.isAnyChildSelectedForEdit(
                    cluster
                );
                const isAnyChildBeingEdited = MapUtil.isAnyChildBeingEdited(
                    cluster
                );
                if (
                    (isSelected ||
                        isPopupOpen ||
                        isHovered ||
                        isSelectedForEdit ||
                        isBeingEdited ||
                        isAnyChildSelected ||
                        isAnyChildHovered ||
                        isAnyChildSelectedForEdit ||
                        isAnyChildBeingEdited ||
                        isPopupAttached) &&
                    isCanvasMarker
                ) {
                    visibleMarkers.push({ ...marker, selected: true });
                    // filtering out selected markers from hovered markers
                } else if (isCanvasMarker) {
                    canvasMarkers.push(marker);
                } else {
                    visibleMarkers.push(marker);
                }
                if (hoveredMarker && hoveredMarker.key === marker.key) {
                    const visibleMarkersIndex = visibleMarkers.findIndex(
                        visibleMarker => visibleMarker.key === marker.key
                    );
                    const visibleMarker = visibleMarkers[visibleMarkersIndex];
                    if (visibleMarkersIndex > -1) {
                        visibleMarkers = [
                            ...visibleMarkers.slice(0, visibleMarkersIndex),
                            {
                                ...visibleMarker,
                                props: { ...visibleMarker.props, $hover: true }
                            },
                            ...visibleMarkers.slice(visibleMarkersIndex + 1)
                        ];
                    } else {
                        visibleMarkers.push({
                            ...marker,
                            props: { ...marker.props, $hover: true }
                        });
                    }
                }
            });
            return {
                // if draggable is false, scroll wheel zoom also won't work.
                // This flag is for to disable map drag while a dragging marker
                draggable: disableDrag ? false : true,
                canvasMarkers,
                visibleMarkers
            };
        }
    )
);

const CanvasHoverMap = canvasHoverMapHOC(canvasHoverMapComponent);
setDisplayName('CanvasHoverMap')(CanvasHoverMap);
export default CanvasHoverMap;
